module.exports = __webpack_public_path__ + "static/media/left-arrow.b73b9dd1.svg";